// Use decoded thumbnail dimensions, never the original image's metadata.
// A cover-cropped image must have enough pixels on BOTH axes. For an edited
// image (object-fit: contain), use its actual fitted size inside the slot.
export function thumbnailPrintDpi({ width, height, slotWidth, slotHeight, pageWidth, pageWidthMm = 305, fit = "cover" }) {
  if (![width, height, slotWidth, slotHeight, pageWidth, pageWidthMm]
    .every((value) => Number.isFinite(value) && value > 0)) return 0;
  const inchesPerCssPixel = pageWidthMm / 25.4 / pageWidth;
  const x = width / (slotWidth * inchesPerCssPixel);
  const y = height / (slotHeight * inchesPerCssPixel);
  return fit === "contain" ? Math.max(x, y) : Math.min(x, y);
}

export function loadThumbnail(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const timer = setTimeout(() => {
      image.onload = image.onerror = null;
      reject(new Error("Thumbnail load timed out"));
    }, 10000);
    image.onload = () => {
      clearTimeout(timer);
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = () => {
      clearTimeout(timer);
      reject(new Error("Thumbnail failed to load"));
    };
    image.src = src;
  });
}
